<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Hooks
	import { onMount } from 'svelte';
	//Services
	import { format } from 'svelte-i18n';
	import { zwaveCall } from 'src/services/xz_http_reqs';
	//Stores
	//Helpers
	import { real_id } from 'src/helpers/interface_helpers';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Types
	//Design system components
	import { Button, Radio, Text } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);

	const inputOptions = ['stored', 'not_stored'];
	const _input_options_i18n = [
		$format('stored_default', { default: 'Stored last state' }),
		$format('not_stored_default', { default: 'Not Stored last state' }),
	];

	let settings = readDeviceSettings(id),
		inputTypes = {},
		deviceChannel = device.channel,
		setting = deviceChannel === 0 ? 17 : 18,
		loading = false,
		cache;

	onMount(() => {
		inputTypes[deviceChannel] = settings?.[`Configuration:0`]?.[setting];
		cache = Object.assign({}, { ...inputTypes });
	});

	const setInputType = (value) => {
		inputTypes[deviceChannel] = value;
	};
	const sentRequest = async () => {
		if (JSON.stringify(cache) !== JSON.stringify(inputTypes)) {
			let isok = false;
			loading = true;

			const res = await zwaveCall(device, {
				cc: 'Configuration',
				m: 'set',
				ep: 0,
				params: [{ parameter: setting, value: +inputTypes[deviceChannel] }],
			});

			if (res.isok) {
				const res_get = await zwaveCall(device, {
					cc: 'Configuration',
					m: 'get',
					ep: 0,
					params: [+setting],
				});
			}
			await onSettingsResponse(res, device);
			loading = false;
		}
	};
</script>

<Text element="h2" styleType="h2" class="mb-s">
	{$format('input_type_desc', { default: 'Set input type' })}
</Text>

{#each inputOptions as option, index}
	<Radio
		size="m"
		selected={inputOptions[inputTypes[deviceChannel]]}
		value={option}
		on:click={() => setInputType(index)}
		id="radio-i1px3rn"
	>
		{_input_options_i18n[index]}
	</Radio>
{/each}

<Button class="mt-s" {loading} size="m" width="full" on:click={sentRequest}>
	{$format('button_save')}
</Button>
